import request from '@/utils/request'

export function syncKepwareDB(params) {
  return request({
    url: '/kepware/db/asset/channel',
    method: 'POST',
    data: params
  })
}

export function getChannel(params) {
  return request({
    url: '/kepware/db/channel/' + params,
    method: 'GET'
  })
}

export function getDevice(params) {
  return request({
    url: '/kepware/db/device/' + params,
    method: 'GET'
  })
}

export function getDeviceEss(params) {
  return request({
    url: '/kepware/db/deviceEss/' + params,
    method: 'GET'
  })
}

export function syncKepwareChannel(params) {
  return request({
    url: '/kepware/channel',
    method: 'POST',
    data: params
  })
}

export function syncKepwareDevice(params) {
  return request({
    url: '/kepware/devices',
    method: 'POST',
    data: params
  })
}

export function syncKepwareTag(params) {
  return request({
    url: '/kepware/tag',
    method: 'POST',
    data: params
  })
}

export function syncKepwareDBDel(params) {
  return request({
    url: '/kepware/db/asset/channel',
    method: 'delete',
    data: params
  })
}

export function syncKepwareChannelDel(params) {
  return request({
    url: '/kepware/channels/' + params,
    method: 'delete'
  })
}

export function syncKepwareDeviceDel(channel, device) {
  return request({
    url: '/kepware/channels/' + channel + '/devices/' + device,
    method: 'delete'
  })
}

export function reScheduler(params) {
  return request({
    url: '/kepware/reScheduler',
    method: 'POST',
    data: params
  })
}
export function siteWSync(params) {
  return request({
    url: '/kepware/siteWSync',
    method: 'POST',
    data: params
  })
}
export function siteEssSync(params) {
  return request({
    url: '/kepware/siteEssSync',
    method: 'POST',
    data: params
  })
}
export function checkDelete(params) {
  return request({
    url: '/kepware/channel/checkDelete',
    method: 'POST',
    data: params
  })
}
